import React, { useRef, type Dispatch, type SetStateAction } from 'react';
import { ImageSourceSizes } from '@ag1/ui';
import { StudioHotspotImageV2 } from 'shared/studio/StudioHotspotImage/StudioHotspotImage';
import { type BaseImage, type SanityKeyed } from 'types/studio/studio';
import { clsx } from 'clsx';
import styles from './ImageCarousel.module.scss';

type ImageCarouselThumbnailsProps = {
  images: SanityKeyed<BaseImage>[];
  selectedSlide: number;
  sizes?: ImageSourceSizes;
  setSelectedSlide: Dispatch<SetStateAction<number>>;
  onClick?: (analyticsType: string) => void;
};

export const ImageCarouselThumbnails = ({
  images,
  selectedSlide,
  sizes,
  setSelectedSlide,
  onClick = () => {}
}: ImageCarouselThumbnailsProps) => {
  const refs = useRef<Map<number, HTMLButtonElement>>(new Map<number, HTMLButtonElement>());

  return (
    <div className={styles.thumbnails} aria-label="Image Carousel Thumbnails" role="group">
      {images.map((image, index) => (
        <button
          className={clsx(styles.thumbnail, selectedSlide === index && styles.selected)}
          key={image._key}
          ref={(node) => {
            if (node) {
              refs.current.set(index, node);
            } else {
              refs.current.delete(index);
            }
          }}
          type="button"
          onClick={() => {
            onClick(`carousel`);
            setSelectedSlide(index);
          }}>
          <StudioHotspotImageV2 image={image} sizes={sizes} />
        </button>
      ))}
    </div>
  );
};
